export function ChevronDown({
  color = '#7A8A99',
  size,
  ...props
}: {
  color: string
  size?: number
}) {
  return (
    <svg
      width={size ?? '12'}
      height={size ?? '7'}
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 0.999999L6 6L1 1"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
